import {booleanAttribute, ChangeDetectorRef, Component, EventEmitter, forwardRef, inject, input, Input, Output} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonIcon, IonItem, IonLabel, IonModal, IonText} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import {caretDownOutline} from 'ionicons/icons';
import {IonicMultiSearchSelectComponent} from '../ionic-multi-search-select/ionic-multi-search-select.component';
import {IonicSingleSearchSelectComponent} from '../ionic-single-search-select/ionic-single-search-select.component';


@Component({
	           selector: 'app-ion-search-select',
	           standalone: true,
	           imports: [
		           FormsModule,
		           IonModal,
		           IonicMultiSearchSelectComponent,
		           IonicSingleSearchSelectComponent,
		           IonIcon,
		           IonLabel,
		           IonItem,
		           IonText
	           ],
	           templateUrl: './ionic-search-select.component.html',
	           styleUrl: './ionic-search-select.component.scss',
	           providers: [
		           {
			           provide: NG_VALUE_ACCESSOR,
			           useExisting: forwardRef(() => IonicSearchSelectComponent),
			           multi: true
		           }
	           ]
           })
export class IonicSearchSelectComponent implements ControlValueAccessor {
	items = input.required<Record<string, unknown>[]>();
	label = input.required<string>();
	displayValue = input.required<string>();
	indexValue = input.required<string>();
	placeholder = input.required<string>();
	color = input<string>('dark');
	title = input.required<string>();

	@Input({transform: booleanAttribute}) allowMulti: boolean = false;

	selectedValue: unknown;

	@Output() valueChange = new EventEmitter<unknown>();

	protected readonly document = document;
	protected readonly IonModal = IonModal;
	private cdr = inject(ChangeDetectorRef);

	constructor() {
		addIcons({caretDownOutline});
	}

	// Méthode pour mettre à jour la valeur du modèle
	writeValue(value: unknown): void {
		this.selectedValue = value;
		this.cdr.detectChanges();
	}

	// Méthode pour gérer les changements effectués dans le composant
	registerOnChange(fn: (value: unknown) => void): void {
		this.onChange = fn;
	}

	// Méthode pour enregistrer la méthode touch (utile pour le formulaire)
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	onValueChanged(value: unknown) {
		this.selectedValue = value;
		this.onChange(value);
		this.onTouched();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange = (_unused: unknown) => {};

	onTouched = () => {};

	getDisplayText(): string {
		if (!this.selectedValue || typeof this.selectedValue !== 'object') {
			return this.placeholder();
		}
		const displayVal = (this.selectedValue as Record<string, unknown>)[this.displayValue()];
		if (displayVal && typeof displayVal === 'string') {
			return displayVal;
		}
		return this.placeholder();
	}

	dismiss(): void {
		(document.getElementById('modal_select_item_' + this.label()) as unknown as IonModal).dismiss().then();
	}

	/** Return focus to the trigger on dismiss (a11y: focus management). */
	onModalDidDismiss(): void {
		const trigger = document.getElementById('select-item' + this.label());
		if (trigger instanceof HTMLElement) {
			trigger.focus();
		}
	}
}
